import { Navigate, useRoutes } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/themes';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import Ambassador from '@/pages/Ambassador';

function Router() {
  return useRoutes([
    { path: '/login', element: <Login /> },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <Home /> },
        { path: 'ambassador', element: <Ambassador /> },
      ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}

export default Router;
